import { Button, Chip, Stack } from "@mui/material";
import { primary25, primary50, primary500 } from "../../theme";
import { Icon } from "../../components/Icon";
import { Loaders } from "../QM/QueryRenderer";
import { generalMessages } from "../../components/messages";
import { useMsg } from "../../components/Msg/Msg";

const textSx = {
  // borderRadius,
  m: "6px",
  p: "6px",
  color: primary500,
  bgcolor: primary25,
};

export const RefreshableChip = ({
  id,
  text,
  onChipClick,
  onRefreshMaybe,
  isLoading,
}) => {
  const msg = useMsg({ dict: generalMessages });
  if (isLoading)
    return <Loaders.Skeleton loaderProps={{ rows: 2, sx: { mb: 1 } }} />;
  if (!text) return null;

  const handleChipClick = () => onChipClick({ text, id });
  const icon = (
    <Icon name="Sync" sx={{ width: 16, height: 16, color: primary500 }} />
  );
  const button = (
    <Button
      size="small"
      variant="text"
      onClick={handleChipClick}
      sx={{
        ...textSx,
        textAlign: "left",
        textTransform: "none",
        fontWeight: "normal",
        lineHeight: "normal",
        "&:hover": {
          bgcolor: primary50,
        },
      }}
    >
      {text}
    </Button>
  );
  // On design, there is badge component (does not make sense, seems more like chip) but button maybe looks better
  // https://www.figma.com/design/rtUziG9eJNToqaN6wRa9Jr/Top-Leader?node-id=738-3553&t=ZaCl0IcVCpcyOt9a-0
  // eslint-disable-next-line no-unused-vars
  const chip = (
    <Chip
      sx={{
        borderRadius: "6px",
        ...textSx,
        height: "auto",
        "& .MuiChip-label": {
          paddingLeft: 0,
          whiteSpace: "pre-wrap",
        },
      }}
      label={text}
      onClick={handleChipClick}
    />
  );

  return (
    <Stack direction="row" spacing={1}>
      {button}
      {!!onRefreshMaybe && (
        <Button
          size="small"
          variant="text"
          startIcon={icon}
          onClick={onRefreshMaybe}
          sx={{ flexShrink: 0, lineHeight: "normal" }}
        >
          {msg("general.regenerate")}
        </Button>
      )}
    </Stack>
  );
};
